<template>
    <div id="payout_history_table_component"
         class="payout-history-table-component">
        <p>Payout history</p>
        <div class="payout-history-table-outer table-responsive">
            <div class="data-loader" v-if="loader"></div>
            <div class="table-outer">
                <table class="table-style1">
                    <thead>
                    <tr>
                        <th>
                            <div class="calendar-icon">
                                <p>Date</p>
                                <i class="mdi mdi-calendar"></i>
                                <datepicker placeholder="range"
                                            :options="{ mode: 'range', maxDate: 'today' }"
                                            v-model="date"></datepicker>
                            </div>
                        </th>
                        <th><p>Amount [FND]</p></th>
                        <th><p>Fee [FND]</p></th>
                        <th><p>Final amount to payout [FND]</p></th>
                        <th><p>Method</p></th>
                        <th><p>Confirmed by you</p></th>
                        <th><p>Status</p></th>
                        <th><p>Reason of rejection</p></th>
                        <th><p></p></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(payout, index) in payouts"
                        :key="index">
                        <td><p>{{ payout.date }}</p></td>
                        <td><p>{{ money.format(payout.amount, 'fnd') }}</p></td>
                        <td><p>{{ money.format(payout.fee, 'fnd') }}</p></td>
                        <td><p>{{ money.format(Number(payout.amount) + Number(payout.fee), 'fnd') }}</p></td>
                        <td><p>{{ payout.method.replace('_', ' ') }}</p></td>
                        <td><p>{{ payout.status === 'new' ? 'no' : 'yes' }}</p></td>
                        <td><p>{{ payout.status }}</p></td>
                        <td><p>{{ payout.reject_reason ? payout.reject_reason : '-' }}</p></td>
                        <td class="operations" v-if="payout.status === 'new'">
                            <a class="button--primary"
                               title="Send email with confirmation link"
                               v-tippy="{ placement : 'top',  arrow: true }"
                               @click="sendConfirmationEmail(payout.id)">
                                <i class="mdi mdi-email"></i>
                            </a>
                            <a class="button--primary"
                               title="Cancel payout"
                               v-tippy="{ placement : 'top',  arrow: true }"
                               @click="cancelPayout(payout.id)">
                                <i class="mdi mdi-close"></i>
                            </a>
                        </td>
                        <td v-else></td>
                    </tr>
                    </tbody>
                </table>
                <p v-if="payouts.length == 0" style="margin-top: 25px;">No results.</p>
            </div>
        </div>
        <pagination-component :current-page="currentPage"
                              :items="items"
                              :loader="loader"
                              :number-of-pages="numberOfPages"
                              :set-items="setItems"
                              :set-page="setPage"></pagination-component>
    </div>
</template>

<script>
    export default {
        dependencies: ['api', 'money', 'popup'],
        data () {
            return {
                date: '',
                loader: false,
                items: 25
            }
        },
        computed: {
            payouts () {
                return this.$store.getters.payouts;
            },
            currentPage () {
                return this.$store.getters.payoutsSettings.currentPage;
            },
            maxPerPage () {
                return this.$store.getters.payoutsSettings.maxPerPage;
            },
            numberOfPages () {
                return this.$store.getters.payoutsSettings.numberOfPages;
            },
        },
        methods: {
            /**
             * Change sort
             */
            changeSort: function (field) {
                this.$store.dispatch('payoutsSetSort', field).then(() => {
                    this.getData();
                });
            },

            /**
             * Set default settings
             */
            clearSettings () {
                this.$store.dispatch('payoutsSettingsClear').then(() => {
                    this.getData();
                    this.items = 25;
                });
            },

            /**
             * Get data with transactions
             */
            getData () {
                this.loader = true;

                let settings = this.$store.getters.payoutsSettings;

                this.$store.dispatch('loadPayouts', {
                    params: settings
                }).then(() => {
                    this.loader = false;
                });
            },

            /**
             * Set number of items per page
             */
            setItems (items) {
                this.items = items;
                this.$store.dispatch('payoutsSetItems', items).then(() => {
                    this.setPage(1);
                });
            },

            /**
             * Set current page
             * @param page
             */
            setPage (page) {
                this.$store.dispatch('payoutsSetPage', page).then(() => {
                    this.getData();
                });
            },

            /**
             * Send confirmation email
             */
            sendConfirmationEmail (id) {
                this.$http.post(this.api.payout.email, {
                    id: id
                }).then(() => {
                    this.popup.show('Confirmation link was sent on your e-mail address.');
                }, error => {
                    this.popup.show(error.body.errors[0].message);
                });
            },

            /**
             * Cancel payout
             */
            cancelPayout (id) {
                this.$http.post(this.api.payout.cancel, {
                    id: id
                }).then(() => {
                    this.$router.push({ 'name': 'Payout' });
                    this.popup.show('Payout was cancelled.');
                }, error => {
                    this.popup.show(error.body.errors[0].message);
                });
            }
        },
        watch: {
            /**
             * Get data with transactions if date in calendar was changed
             */
            date () {
                this.$store.dispatch('payoutsSetDate', this.date).then(() => {
                    this.getData();
                });
            }
        },
        beforeMount () {
            let settings = this.$store.getters.payoutsSettings;

            this.$store.dispatch('loadPayouts', {
                params: settings
            }).then(() => {
                this.items = settings.maxPerPage;
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .payout-history-table-component{
        position: relative;
    }

    .payout-history-table-outer{
        margin-top: 11px;
        thead,
        tbody{
            tr{
                th,
                td{
                    &:first-child{
                        width: 14%;
                    }
                }
            }
        }
    }
    
    .operations{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/payout-history/PayoutHistoryTable.vue